/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Row, Col } from "reactstrap";
const TemplateInstructions = ({
setIsSystemRedirection,
isSystemRedirection,
data,
isLoaded,
onSubmit,
isSubmitting,
onUpdate,
template_data,
use_template,
generated_data,
}) => {
    return (
        <Row className="g-0 justify-content-center pt-5 min-h-84">
            <Col className="col-9">
            <div class="col-12 p-0 align-items-center rounded-5 border mt-2 bg-white px-5 py-4">
                <div className="col-12 pb-3 bg-white rounded-header fs-5">
                   <b>Your generated task will be shown here</b>
                </div>
                <p className="border-bottom"></p>
                <div className="col-12 pt-3">
                    <div className="lh-base pb-1"><span className="pe-1">1.</span> Set up your task </div>
                   <div className="lh-base pb-1"><span className="pe-1">2.</span> Clearly define the topic / learning objective</div>
                   <div className="lh-base pb-1"><span className="pe-1">3.</span> Click “generate” to create your task based on the template</div>
                   <div className="lh-base fst-italic">Need help? <a href="#">Watch our how to video.</a></div>
                </div>
                {/* <div className="col-12 p-4 py-0">
                   <p className="fst-italic">Output style example:</p>
                    { !template_data && !use_template && !generated_data ? (
                        <div className="pt-2 pb-3">
                            <img src={`${imageURl}/custom_temp.png`} height="50%" alt="custom_template" />
                        </div>
                    ): data.task_type === exerciseType.WRITING_TASK ? (
                        <WrittingQuiz
                            setIsSystemRedirection={setIsSystemRedirection}
                            isSystemRedirection={isSystemRedirection}
                            data={data}
                            isLoaded={isLoaded}
                            onSubmit={onSubmit}
                            isSubmitting={isSubmitting}
                            onUpdate={onUpdate}
                        />
                    ) : data.detail ? (
                        <Error data={data} isLoaded={isLoaded} />
                    ) : (
                        <QuizRunner
                            setIsSystemRedirection={setIsSystemRedirection}
                            isSystemRedirection={isSystemRedirection}
                            data={data}
                            isLoaded={isLoaded}
                            onSubmit={onSubmit}
                            isSubmitting={isSubmitting}
                            onUpdate={onUpdate}
                        />
                    )}
                </div> */}
            </div>
            </Col>
        </Row>
    )
};
export default TemplateInstructions;